import React, {createContext, useContext, useReducer} from 'react'
import {AsmlDeviceOverviewReducer} from "../reducer/AsmlDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const AsmlDeviceOverviewContext = createContext();

const AsmlDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        inductCameraDeviceInformation: {},
        printerDeviceInformation: {},
        verificationCameraDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(AsmlDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <AsmlDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AsmlDeviceOverviewContext.Provider>
    )
}

export default AsmlDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/context/AsmlDeviceOverviewContext.js